import Vue from 'vue';
import aos from 'aos';

Vue.directive('aos', aos);
